import { render, staticRenderFns } from "./PaymentHistoryChart.vue?vue&type=template&id=35611f9e&"
import script from "./PaymentHistoryChart.vue?vue&type=script&lang=js&"
export * from "./PaymentHistoryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports